/**
 * reducers/login.js
 */

const initialState = {
  result: undefined,
  error: false
}
export default (state = initialState,action) => {
  switch (action.type){
    case 'SUCCESS':
      return {
        result:true,
        error:false
      }
    case 'LOGIN_ERROR':
      return {
        result:false,
        error:"メールアドレスまたはパスワードが間違っています"
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/login.js